import React from 'react';
import ResponsiveImage from 'components/ResponsiveImage';
import Link, { LINK_BEHAVIORS, LINK_SIZES } from 'components/Link';
import PropTypes from 'prop-types';

const ContactPersonsBlockContact = ({ image, name, position, url }) => {
  return (
    <div className="contact-persons-block-contact">
      <div className="contact-persons-block-contact__image">
        <ResponsiveImage
          {...image}
          loading="lazy"
          className="responsive-image_size_contact-persons-block"
          sources={[
            {
              width: 60,
              height: 60,
            },
          ]}
        />
      </div>
      <div className="contact-persons-block-contact__info">
        <Link
          url={url}
          text={name}
          size={LINK_SIZES.small}
          behavior={LINK_BEHAVIORS.text}
          className="contact-persons-block-contact__link"
        />
        {position && (
          <span className="contact-persons-block-contact__position">
            {position}
          </span>
        )}
      </div>
    </div>
  );
};

ContactPersonsBlockContact.propTypes = {
  url: PropTypes.string,
  image: PropTypes.exact(ResponsiveImage.propTypes),
  name: PropTypes.string,
  position: PropTypes.string,
};

export default ContactPersonsBlockContact;
